export const FREE_ADVANTAGES_PERKS = [
    "Free plan available",
    "No credit card required",
    "Cancel anytime"
]